import { createSlice } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getAccountCustomLinkButtonData = createAsyncThunk(
  'accountCustomLinkButtonSlice/getAccountCustomLinkButtonData',
  async (params: { AccountID: string }) => {
    console.log('getAccountIntegrationConfig params', params);
    const { AccountID } = params;
    const response = await api.get(
      `/account/${AccountID.toLowerCase()}/get_custom_link_data`,
      { timeout: 30000 }
    );
    console.log('getAccountIntegrationConfig response', response);
    return response.data;
  }
);
export const updateAccountCustomLinkButtonData = createAsyncThunk(
  'accountCustomLinkButtonSlice/updateAccountCustomLinkButtonData',
  async (params: {
    AccountID: string,
    CustomLinkButtonText: string,
    CustomLinkButtonUrl: string,
    CustomLinkButtonImage?: string,
  }) => {
    console.log('updateAccountCustomLinkButtonData params', params);
    const { AccountID, CustomLinkButtonText, CustomLinkButtonUrl, CustomLinkButtonImage } = params;

    const formData = new FormData();
    formData.append('CustomLinkButtonText', CustomLinkButtonText);
    formData.append('CustomLinkButtonUrl', CustomLinkButtonUrl);

    if (CustomLinkButtonImage) {
      formData.append('CustomLinkButtonImage', CustomLinkButtonImage);
    }

    const response = await api.put(
      `/account/${AccountID.toLowerCase()}/update_account_custom_link_button`,
      formData,
      {
        timeout: 30000,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    console.log('updateAccountCustomLinkButtonData response', response);
    return response.data;
  }
);


const initialState: {
  getData: {
    status: string;
    error: string;
    pending: boolean;
    complete: boolean;
  }
  updateData: {
    status: string;
    error: string;
    pending: boolean;
    complete: boolean;
  }
  config: {
    CustomLinkButtonText: string,
    CustomLinkButtonUrl: string,
    CustomLinkButtonImageUrl: string
  };
} = {
  getData: {
    status: '',
    error: '',
    pending: false,
    complete: false,
  },
  updateData: {
    status: '',
    error: '',
    pending: false,
    complete: false,
  },
  config: {
    CustomLinkButtonText: '',
    CustomLinkButtonUrl: '',
    CustomLinkButtonImageUrl: '',
  }, // config
};

const accountCustomLinkButtonSlice = createSlice({
  name: 'accountCustomLinkButtonSlice',
  initialState,
  reducers: {
    resetCustomLinkButtonState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getAccountCustomLinkButtonData.pending, (state) => {
      console.log('getAccountCustomLinkButtonData.pending');
      state.getData = {
        status: 'loading',
        pending: true,
        complete: false,
        error: ''
      }
    });

    builder.addCase(getAccountCustomLinkButtonData.fulfilled, (state, action) => {
      console.log('getAccountCustomLinkButtonData.fulfilled ', action);
      state.getData = {
        status: 'success',
        pending: false,
        complete: true,
        error: '',
      }
      state.config = action.payload;
    });

    builder.addCase(getAccountCustomLinkButtonData.rejected, (state, action) => {
      console.log('getAccountCustomLinkButtonData.rejected action', action);
      console.log(
        'getAccountCustomLinkButtonData.rejected action payload',
        action.payload
      );
      state.getData = {
        status: 'error',
        pending: false,
        complete: false,
        error: action.error ? action.error.message! : '',
      }
    });
    builder.addCase(updateAccountCustomLinkButtonData.pending, (state) => {
      console.log('updateAccountCustomLinkButtonData.pending');
      state.updateData = {
        status: 'loading',
        pending: true,
        complete: false,
        error: '',
      }
    });

    builder.addCase(updateAccountCustomLinkButtonData.fulfilled, (state, action) => {
      console.log('updateAccountCustomLinkButtonData.fulfilled ', action);
      state.updateData = {
        status: 'success',
        pending: false,
        complete: true,
        error: '',
      }
      state.config = action.payload;
    });

    builder.addCase(updateAccountCustomLinkButtonData.rejected, (state, action) => {
      console.log('updateAccountCustomLinkButtonData.rejected action', action);
      console.log(
        'updateAccountCustomLinkButtonData.rejected action payload',
        action.payload
      );
      state.updateData = {
        status: 'error',
        pending: false,
        complete: false,
        error: action.error ? action.error.message! : '',
      }
    });
  },
});

export const { resetCustomLinkButtonState } = accountCustomLinkButtonSlice.actions;
export default accountCustomLinkButtonSlice;